import { useFormik } from "formik";
import React from "react";
import {
  BsBookmarkStarFill,
  BsFillPersonFill,
  BsPencil,
  BsPlus,
  BsRobot,
} from "react-icons/bs";
import { toast } from "react-toastify";
import * as Yup from "yup";
import orgApi from "../../../api/org_api";
import {
  Button,
  CustomInput,
  Label,
  Modal,
  SearchableDropdown,
} from "../../../component/common";
import S from "../../../Services/GeneralServices";
import SelectFavourites from "./SelectFavourites";
import SelectGroups from "./SelectGroup";

type SetupInterviewProps = {
  setLoading: Function;
  setLevel: Function;
  setBackUploadJd: Function;
  fromPage: String;
};

const SetupInterview: React.FC<SetupInterviewProps> = ({
  setLoading,
  setLevel,
  setBackUploadJd,
  fromPage,
}: SetupInterviewProps) => {
  const [showAddRoundModal, setShowAddRoundModal] = React.useState(false);
  const [roundType, setRoundType] = React.useState("add");
  const [jdDetail, setJdDetail] = React.useState();
  const [roundId, setRoundId] = React.useState("");
  const [roundMode, setRoundMode] = React.useState("Manual");
  const [intType, setIntType] = React.useState("other");
  const [inhouse, setInhouse] = React.useState(true);
  const [external, setExternal] = React.useState(false);
  const [market, setMarket] = React.useState(true);
  const [favCount, setFavCount] = React.useState(0);
  const [isFirst, setIsFirst] = React.useState(true);
  const [fromType, setFromType] = React.useState("");

  const [showAddInterviewerModal, setShowAddInterviewerModal] =
    React.useState(false);
  const [addGroupModal, setAddGroupModal] = React.useState(false);
  const [groups, setgroups] = React.useState([] as any);

  React.useEffect(() => {
    setIsFirst(true);
    fetchJdDetails();
  }, []);

  const fetchJdDetails = async () => {
    var pId = localStorage.getItem("createPostId");
    setLoading(true);
    if (
      S.getOrgDomain() === "sightspectrum.com" ||
      S.getOrgDomain() === "vegaintellisoft.com" ||
      S.getOrgDomain() === "nam-it.com" ||
      S.getOrgDomain() === "infinitisoftware.net"
    ) {
      setMarket(false);
    }
    const res = await orgApi.getSingleJdDetail(pId);
    if (res.data.success) {
      setFavCount(res.data.post.fav_count);
      if (res.data.post.round.length === 1 && isFirst && fromPage === "jd") {
        var d = res.data.post.round[0];
        if (d.new + d.scheduled + d.completed + d.selected === 0) {
          editRound(d);
        }
      }
      res.data.post.round.length !== 0 &&
        res.data.post.round.push({ isNew: true });
      setJdDetail(res.data.post);
    } else {
      setJdDetail(undefined);
    }
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: { name: "", type: "", mode: "Manual" },
    validationSchema: Yup.object({
      name: Yup.string().required("Round name is required"),
      type: Yup.string().required("Select Type"),
    }),
    validateOnBlur: true,
    onSubmit: async (values) => {
      if (intType === "other") {
        if (!inhouse && !external && !market) {
          toast("Select Interviewers");
          return;
        }
      } else {
        setInhouse(false);
        setExternal(false);
        setMarket(false);
      }

      setLoading(true);
      // setisDisabled(true);
      if (roundType === "add") {
        var reqData = {
          name: values.name,
          type: values.type,
          mode: values.mode,
          level: jdDetail ? (jdDetail["round"] as any).length : 1,
          post_id: localStorage.getItem("createPostId")!,
          fav: intType === "fav" ? true : false,
          house: intType !== "fav" && intType !== "group" ? inhouse : false,
          market: intType !== "fav" && intType !== "group" ? market : false,
          external: intType !== "fav" && intType !== "group" ? external : false,
          group: intType === "group" ? true : false,
          i_group: groups,
        };
        const res = await orgApi.addRound(reqData);
        if (res.data.success) {
          setShowAddRoundModal(false);
          toast(res.data.msg);
          fetchJdDetails();
        } else {
          toast(res.data.msg);
        }
        // setisDisabled(false);
        setLoading(false);
      } else if (roundType === "edit") {
        var reqData1 = {
          name: values.name,
          type: values.type,
          mode: values.mode,
          round_id: roundId,
          fav: intType === "fav" ? true : false,
          house: intType !== "fav" && intType !== "group" ? inhouse : false,
          market: intType !== "fav" && intType !== "group" ? market : false,
          external: intType !== "fav" && intType !== "group" ? external : false,
          group: intType === "group" ? true : false,
        };
        const res = await orgApi.editRound(reqData1);
        if (res.data.success) {
          setShowAddRoundModal(false);
          toast(res.data.msg);
          fetchJdDetails();
        } else {
          toast(res.data.msg);
        }
        // setisDisabled(false);
        setLoading(false);
      }
    },
  });

  const addRound = () => {
    formik.values.name = "";
    formik.values.type = "";
    formik.values.mode = "Manual";
    setRoundMode("Manual");
    setRoundId("");
    formik.resetForm();
    setRoundType("add");
    setIntType("other");
    setInhouse(true);
    setMarket(true);
    if (
      S.getOrgDomain() === "sightspectrum.com" ||
      S.getOrgDomain() === "vegaintellisoft.com" ||
      S.getOrgDomain() === "nam-it.com" ||
      S.getOrgDomain() === "infinitisoftware.net"
    ) {
      setMarket(false);
    }
    setShowAddRoundModal(true);
  };

  const editRound = (val: any) => {
    formik.values.name = val.name;
    formik.values.type = val.type;
    formik.values.mode = val.mode;
    setRoundMode(val.mode);
    setRoundId(val.id);
    setExternal(val.external);
    setInhouse(val.house);
    setMarket(val.market);

    if (val.external || val.house || val.market) {
      setIntType("other");
    } else {
      setIntType("fav");
    }
    setRoundType("edit");
    setShowAddRoundModal(true);
    setIsFirst(false);
  };

  const moveNextLevel = () => {
    if (jdDetail) {
      setLevel(jdDetail["round"][0]);
    }
  };

  const setCallback = () => {
    fetchJdDetails();
    setShowAddInterviewerModal(false);
  };
  const setGroupCallback = (grp: any) => {
    if (roundType === "edit") {
      setAddGroupModal(false);
    } else {
      setgroups(grp);
      setAddGroupModal(false);
    }
  };
  const setfromType = (type: any) => {
    setFromType(type);
    setShowAddInterviewerModal(true);
  };
  const intGroup = () => {
    setAddGroupModal(true);
  };
  return (
    <>
      {showAddRoundModal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="fixed inset-0 w-full h-full bg-black opacity-40"></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white shadow-lg rounded-sm rounded-br-3xl">
                <div className="sm:flex">
                  <div className="mt-1 text-center sm:text-left w-full">
                    <div className="flex items-center justify-between border-b">
                      <h6 className="text-sm font-bold text-gray-800 mb-2">
                        {roundType === "add" ? "Add" : "Edit"} Round
                      </h6>
                    </div>
                    <div className="mt-1">
                      <form onSubmit={formik.handleSubmit}>
                        <div className="grid md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 sm:grid-cols-1 ">
                          <div className="my-2 lg:mx-5 md:mx-5 xl:mx-5">
                            <div className="flex flex-row item-center justify-center mb-3 gap-5">
                              <div className="flex items-center gap-2">
                                <input
                                  checked={roundMode === "Manual"}
                                  id="default-radio-1"
                                  type="radio"
                                  value="Manual"
                                  name="default-radio"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => {
                                    formik.values.mode = "Manual";
                                    setRoundMode("Manual");
                                  }}
                                ></input>
                                <Label text="Manual" />
                              </div>
                              <div className="flex items-center gap-2 disabled-div">
                                <input
                                  checked={roundMode === "AI"}
                                  id="default-radio-4"
                                  type="radio"
                                  value="AI"
                                  name="default-radio-4"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => {
                                    formik.values.mode = "AI";
                                    setRoundMode("AI");
                                  }}
                                ></input>
                                <Label text="AI" />
                              </div>
                            </div>

                            <CustomInput
                              label="Title"
                              placeholder="Round Name"
                              type="text"
                              name="name"
                              value={formik.values.name}
                              onBlur={formik.handleBlur}
                              onChange={formik.handleChange}
                              isError={
                                !!formik.touched.name && !!formik.errors.name
                              }
                              errorMessage={formik.errors.name}
                            ></CustomInput>
                          </div>
                          <div className="my-2 lg:mx-5 md:mx-5 xl:mx-5">
                            <SearchableDropdown
                              label="Type"
                              options={[
                                { label: "Technical", value: "Technical" },
                                { label: "HR", value: "HR" },
                              ]}
                              value={formik.values.type}
                              onChange={(e) =>
                                formik.setFieldValue("type", e.value)
                              }
                              isError={
                                !!formik.touched.type && !!formik.errors.type
                              }
                              errorMessage={formik.errors.type}
                            />
                          </div>

                          <div className="my-2 lg:mx-5 md:mx-5 xl:mx-5">
                            <Label text="Interviewer" />
                            <div className="flex flex-row item-center justify-between mb-3 mt-2 gap-5 grid grid-cols-3">
                              <div className="flex items-center gap-2">
                                <input
                                  checked={intType === "other"}
                                  id="default-radio-2"
                                  type="radio"
                                  value={intType}
                                  name="default-radio-2"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => setIntType("other")}
                                ></input>
                                <label className="text-gray-500 text-xs font-normal">
                                  Interviewer type
                                </label>
                              </div>
                              <div className="flex items-center gap-2">
                                <input
                                  checked={intType === "fav"}
                                  id="default-radio-3"
                                  value={intType}
                                  type="radio"
                                  name="default-radio-3"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => setIntType("fav")}
                                ></input>
                                <label className="text-gray-500 text-xs font-normal">
                                  Favourites
                                </label>
                              </div>
                              <div className="flex items-center gap-2">
                                <input
                                  checked={intType === "group"}
                                  id="default-radio-3"
                                  value={intType}
                                  type="radio"
                                  name="default-radio-3"
                                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                                  onChange={() => setIntType("group")}
                                ></input>
                                <label className="text-gray-500 text-xs font-normal">
                                  Group
                                </label>
                              </div>
                            </div>
                            {intType === "other" && (
                              <div className="flex flex-col items-start">
                                <div
                                  className="inline-flex items-center"
                                  onClick={() => setInhouse(!inhouse)}
                                >
                                  <label className="relative flex items-center p-3 rounded-full cursor-pointer">
                                    <input
                                      type="checkbox"
                                      checked={inhouse ? true : false}
                                      className="before:content[''] peer relative h-3 w-3 cursor-pointer appearance-none rounded-sm border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-600 hover:before:opacity-10"
                                      id="check"
                                    />
                                    <span className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        stroke="currentColor"
                                        stroke-width="1"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clip-rule="evenodd"
                                        ></path>
                                      </svg>
                                    </span>
                                  </label>
                                  <label
                                    className="mt-px font-light text-gray-700 text-xs cursor-pointer select-none"
                                    htmlFor="check"
                                  >
                                    In-House
                                  </label>
                                </div>
                                <div
                                  className="inline-flex items-center"
                                  onClick={() => setExternal(!external)}
                                >
                                  <label className="relative flex items-center p-3 rounded-full cursor-pointer">
                                    <input
                                      type="checkbox"
                                      checked={external ? true : false}
                                      className="before:content[''] peer relative h-3 w-3 cursor-pointer appearance-none rounded-sm border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-600 hover:before:opacity-10"
                                      id="check1"
                                    />
                                    <span className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        stroke="currentColor"
                                        stroke-width="1"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clip-rule="evenodd"
                                        ></path>
                                      </svg>
                                    </span>
                                  </label>
                                  <label
                                    className="mt-px font-light text-gray-700 text-xs cursor-pointer select-none"
                                    htmlFor="check1"
                                  >
                                    External
                                  </label>
                                </div>
                                <div
                                  className="inline-flex items-center"
                                  onClick={() => setMarket(!market)}
                                >
                                  <label className="relative flex items-center p-3 rounded-full cursor-pointer">
                                    <input
                                      type="checkbox"
                                      checked={market ? true : false}
                                      className="before:content[''] peer relative h-3 w-3 cursor-pointer appearance-none rounded-sm border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-600 hover:before:opacity-10"
                                      id="check2"
                                    />
                                    <span className="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-3.5 w-3.5"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        stroke="currentColor"
                                        stroke-width="1"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clip-rule="evenodd"
                                        ></path>
                                      </svg>
                                    </span>
                                  </label>
                                  <label
                                    className="mt-px font-light text-gray-700 text-xs cursor-pointer select-none"
                                    htmlFor="check2"
                                  >
                                    Market place
                                  </label>
                                </div>
                              </div>
                            )}
                            {intType === "fav" && (
                              <>
                                <div className="gap-2 flex flex-col items-center">
                                  <button
                                    type="button"
                                    className={
                                      "mt-2 py-1.5 px-2 text-gray-500 outline-none border text-xs rounded w-1/3 flex flex-row items-center justify-center gap-2"
                                    }
                                    onClick={() => setfromType("viewFav")}
                                  >
                                    <span className="flex items-center gap-2">
                                      <BsBookmarkStarFill /> {favCount}{" "}
                                    </span>
                                    Favourites
                                  </button>
                                  <button
                                    type="button"
                                    className={
                                      "mt-2 py-1.5 px-2 text-gray-500 outline-none border text-xs rounded w-1/3 flex flex-row items-center justify-center gap-2"
                                    }
                                    onClick={() => setfromType("addFav")}
                                  >
                                    <BsPlus />
                                    Add Favourites
                                  </button>
                                </div>
                              </>
                            )}
                            {intType === "group" && (
                              <>
                                <div className="gap-2 flex flex-col items-end">
                                  <button
                                    type="button"
                                    className={
                                      "mt-2 py-1.5 px-2 text-gray-500 outline-none border text-xs rounded w-1/3 flex flex-row items-center justify-center gap-2"
                                    }
                                    onClick={() => intGroup()}
                                  >
                                    <BsPlus />
                                    {roundType === "add" && groups.length}{" "}
                                    Interviewer Group
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        {/* <div className=" gap-2 mt-3 sm:flex md:flex lg:flex justify-end">
                          <Button
                            text="Cancel"
                            variant="outlined"
                            onClick={() => setShowAddRoundModal(false)}
                            type="button"
                          />
                          <Button
                            text="Save"
                            onClick={() => setShowAddRoundModal(false)}
                            type="submit"
                          />
                        </div> */}

                        <div className=" gap-2 mt-3 sm:flex md:flex lg:flex justify-end">
                          <Button
                            text="Cancel"
                            variant="outlined"
                            onClick={() => setShowAddRoundModal(false)}
                            type="button"
                          />
                          <Button text="save" type="submit" />
                          {/* <
                          <button
                            type="submit"
                          >
                            Save
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showAddInterviewerModal && (
        <>
          <Modal
            size="4xl"
            isOpen={showAddInterviewerModal}
            onClose={() => setShowAddInterviewerModal(false)}
            title="Add Interviewer"
            children={
              <SelectFavourites
                callBack={setCallback}
                postId={localStorage.getItem("createPostId")!}
                from_type={fromType}
              />
            }
          />
        </>
      )}
      {addGroupModal && (
        <Modal
          size="4xl"
          isOpen={addGroupModal}
          onClose={() => setAddGroupModal(false)}
          title="Add Interviewer Groups"
          children={
            <SelectGroups
              callBack={setGroupCallback}
              selectedGroups={groups}
              roundId={roundType === "add" ? null : roundId}
            />
          }
        />
      )}
      {jdDetail && (
        <div className="overflow-y-auto flex flex-col space-y-4 justify-between h-[calc(100vh-150px)] 2xl:h-[calc(100vh-190px)] ">
          <div className="flex flex-col bg-white  overflow-y-auto">
            <div className="flex-1 flex justify-center p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-6xl">
                {(jdDetail["round"] as any).map((value: any, index: number) => (
                  <div key={value.id}>
                    {(jdDetail["round"] as any).length - 1 !== index && (
                      <div className="bg-white border border-gray-200 rounded-lg py-3 px-4 h-64 flex flex-col gap-2 hover:shadow-md transition-shadow cursor-pointer">
                        {/* Header with icon, title, and edit button */}
                        <div className="flex items-start justify-between gap-3 border-b border-gray-100 pb-2">
                          <div className="flex items-start gap-3 flex-1">
                            <div className="mt-0.5 text-lg text-blue-600">
                              {value.mode === "Manual" && <BsFillPersonFill />}
                              {value.mode === "AI" && <BsRobot />}
                            </div>
                            <div className="flex flex-col gap-1 flex-1 min-w-0">
                              <h3 className="text-sm font-semibold text-gray-900 truncate">
                                {value.name}
                              </h3>
                              <p className="text-xs text-gray-500 truncate">
                                {value.type}
                              </p>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() => editRound(value)}
                            className="px-2.5 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 transition-colors flex items-center gap-1.5 whitespace-nowrap"
                          >
                            <BsPencil size={12} />
                            Edit
                          </button>
                        </div>

                        {/* Stats section */}
                        <div className="flex flex-col gap-2 flex-1">
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-gray-500 font-normal w-20">
                              New:
                            </span>
                            <span className="font-semibold text-gray-900">
                              {value.new}
                            </span>
                          </div>
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-gray-500 font-normal w-20">
                              Scheduled:
                            </span>
                            <span className="font-semibold text-gray-900">
                              {value.scheduled}
                            </span>
                          </div>
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-gray-500 font-normal w-20">
                              Completed:
                            </span>
                            <span className="font-semibold text-gray-900">
                              {value.completed}
                            </span>
                          </div>
                          <div className="flex items-center justify-between text-xs">
                            <span className="text-gray-500 font-normal w-20">
                              Selected:
                            </span>
                            <span className="font-semibold text-gray-900">
                              {value.selected}
                            </span>
                          </div>
                        </div>

                        {/* Interviewers and total count section */}
                        <div className="flex items-end justify-between pt-2 border-t border-gray-100">
                          <div className="flex flex-col gap-0.5">
                            <h4 className="text-xs font-semibold text-gray-700">
                              Interviewers
                            </h4>
                            <div className="space-y-0.5">
                              {value.fav && (
                                <p className="text-xs text-gray-500">
                                  Favourites
                                </p>
                              )}
                              {value.group && (
                                <p className="text-xs text-gray-500">Groups</p>
                              )}
                              {value.external && (
                                <p className="text-xs text-gray-500">
                                  External
                                </p>
                              )}
                              {value.house && (
                                <p className="text-xs text-gray-500">
                                  In House
                                </p>
                              )}
                              {value.market && (
                                <p className="text-xs text-gray-500">
                                  Market Place
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="text-5xl font-bold text-blue-600">
                            {value.new +
                              value.scheduled +
                              value.completed +
                              value.selected}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Add round card */}
                    {(jdDetail["round"] as any).length - 1 === index && (
                      <div
                        onClick={() => addRound()}
                        className="bg-blue-100 border border-dashed hover:text-blue-700 border-blue-700 rounded-lg p-5 h-64 flex flex-col items-center justify-center cursor-pointer hover:bg-blue-200 transition-colors"
                      >
                        <div className="text-5xl font-bold  mb-2">+</div>
                        <div className="text-sm font-semibold ">Add Round</div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end gap-2">
            <Button
              type="button"
              onClick={() => setBackUploadJd()}
              text="Back"
              variant="outlined"
            />
            <Button
              type="button"
              onClick={() => moveNextLevel()}
              text="Save & Next"
            />
          </div>
        </div>
      )}
    </>
  );
};
export default SetupInterview;
